import script from "./Approval.vue?vue&type=script&lang=ts&setup=true"
export * from "./Approval.vue?vue&type=script&lang=ts&setup=true"

import "./Approval.vue?vue&type=style&index=0&id=405d5d48&scoped=true&lang=less"
import "./Approval.vue?vue&type=style&index=1&id=405d5d48&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-405d5d48"]])

export default __exports__